import { env } from '@campai/lib-web/env'
import { getProductProfile } from '@campai/lib-common/utils/misc'

export const newOrganizationAvailableCountries = getProductProfile(env.VITE_PRODUCT_KEY).organization.countries
